import { useTheme, Avatar, Box } from '@mui/material';
import { tokens } from '../../global/theme/tokens';

const ExoAvatar = ({
  onClick,
  className = '',
  id = '',
  sx = {},
  name = '',
  picture,
  color,
  size = '64px',
  type = 'contact',
  icon = null,
  bgcolor,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const mode = theme.palette.mode;
  if (!picture) {
    type = 'contact';
  }

  function stringToColor(name) {
    // Normalize so differently-formatted strings for the same name
    // (extra/leading whitespace) hash to the same color
    const normalized = name?.trim().replace(/\s+/g, ' ');
    if (!normalized) return colors.card;
    let hash = 0;

    // Create a hash from the string
    for (let i = 0; i < normalized.length; i++) {
      hash = normalized.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Use the hash to generate a hue value (0–360)
    const hue = hash % 360;

    // Fixed saturation and lightness for consistency and readability
    return mode === 'dark' ? `hsl(${hue}, 45%, 35%)` : `hsl(${hue}, 70%, 70%)`;
  }

  const colorToUse = color || stringToColor(name);

  return (
    <Avatar
      onClick={onClick}
      id={id}
      src={picture}
      alt="ExoAvatar"
      className={className}
      sx={{
        ...sx,
        borderRadius: type === 'company' ? '0px' : '50%',
        width: size,
        height: size,
        bgcolor: picture && !bgcolor ? 'transparent' : colorToUse,
        '& img': {
          objectFit: type === 'company' ? 'contain' : 'cover',
        },
        border: `1px solid transparent`,
        cursor: onClick ? 'pointer' : 'auto',
        ':hover': {
          bgcolor: onClick ? colors.info + '30' : 'auto',
          border: onClick ? `1px solid ${colors.info}80` : 'auto',
        },
      }}
    >
      <Box
        className="h-full w-full flex justify-center items-center"
        sx={{
          fontSize: 'calc(' + size + ' / 2.5)',
          color: colors.grey[700],
        }}
      >
        {icon ? icon : getInitials(name)}
      </Box>
    </Avatar>
  );
};

// FUNCTIONS
export function getInitials(name = '') {
  // Match words made of letters or numbers (at least 1 char)
  const rgx = /([\p{L}\p{N}])[\p{L}\p{N}]*/gu;

  // The default above only covers undefined; a record without a name sends null
  let initials = [...(name || '').matchAll(rgx)] || [];

  initials = (
    (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
  ).toUpperCase();

  return initials;
}

// export function getInitials(name) {
//   let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

//   let initials = [...name.matchAll(rgx)] || [];

//   initials = (
//     (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
//   ).toUpperCase();

//   return initials;
// }

export default ExoAvatar;
